/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v1
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../model';
// @ts-ignore
import type { OrganizationRoleWithRights } from '../model';
// @ts-ignore
import type { PlatformRoleWithRights } from '../model';
// @ts-ignore
import type { ProjectRightsGrouped } from '../model';
// @ts-ignore
import type { ProjectRoleWithRights } from '../model';
/**
 * RolesApi - axios parameter creator
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return all project rights.  Returns:     schemas.Rights: The rights.
         * @summary Get All Project Rights
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectRightsRolesProjectsRightsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/roles/projects/rights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return all user organization roles and rights.  Returns:     schemas.RoleWithRights: The roles.
         * @summary Get Organizations Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsRolesRolesOrganizationsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/roles/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return all user platform roles and rights.  Returns:     schemas.PlatformRoleWithRights: The roles.
         * @summary Get Platform Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformRolesRolesPlatformGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/roles/platform`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return all user project roles and rights.  Returns:     schemas.RoleWithRights: The roles.
         * @summary Get Project Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRolesRolesProjectsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/roles/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesApi - functional programming interface
 */
export const RolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration)
    return {
        /**
         * Return all project rights.  Returns:     schemas.Rights: The rights.
         * @summary Get All Project Rights
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProjectRightsRolesProjectsRightsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRightsGrouped>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProjectRightsRolesProjectsRightsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.getAllProjectRightsRolesProjectsRightsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return all user organization roles and rights.  Returns:     schemas.RoleWithRights: The roles.
         * @summary Get Organizations Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsRolesRolesOrganizationsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationRoleWithRights>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsRolesRolesOrganizationsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.getOrganizationsRolesRolesOrganizationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return all user platform roles and rights.  Returns:     schemas.PlatformRoleWithRights: The roles.
         * @summary Get Platform Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlatformRolesRolesPlatformGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlatformRoleWithRights>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlatformRolesRolesPlatformGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.getPlatformRolesRolesPlatformGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return all user project roles and rights.  Returns:     schemas.RoleWithRights: The roles.
         * @summary Get Project Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectRolesRolesProjectsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectRoleWithRights>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectRolesRolesProjectsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.getProjectRolesRolesProjectsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RolesApi - factory interface
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolesApiFp(configuration)
    return {
        /**
         * Return all project rights.  Returns:     schemas.Rights: The rights.
         * @summary Get All Project Rights
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectRightsRolesProjectsRightsGet(options?: RawAxiosRequestConfig): AxiosPromise<ProjectRightsGrouped> {
            return localVarFp.getAllProjectRightsRolesProjectsRightsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Return all user organization roles and rights.  Returns:     schemas.RoleWithRights: The roles.
         * @summary Get Organizations Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsRolesRolesOrganizationsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganizationRoleWithRights>> {
            return localVarFp.getOrganizationsRolesRolesOrganizationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Return all user platform roles and rights.  Returns:     schemas.PlatformRoleWithRights: The roles.
         * @summary Get Platform Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlatformRolesRolesPlatformGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<PlatformRoleWithRights>> {
            return localVarFp.getPlatformRolesRolesPlatformGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Return all user project roles and rights.  Returns:     schemas.RoleWithRights: The roles.
         * @summary Get Project Roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRolesRolesProjectsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProjectRoleWithRights>> {
            return localVarFp.getProjectRolesRolesProjectsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolesApi - object-oriented interface
 */
export class RolesApi extends BaseAPI {
    /**
     * Return all project rights.  Returns:     schemas.Rights: The rights.
     * @summary Get All Project Rights
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllProjectRightsRolesProjectsRightsGet(options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).getAllProjectRightsRolesProjectsRightsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return all user organization roles and rights.  Returns:     schemas.RoleWithRights: The roles.
     * @summary Get Organizations Roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationsRolesRolesOrganizationsGet(options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).getOrganizationsRolesRolesOrganizationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return all user platform roles and rights.  Returns:     schemas.PlatformRoleWithRights: The roles.
     * @summary Get Platform Roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlatformRolesRolesPlatformGet(options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).getPlatformRolesRolesPlatformGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return all user project roles and rights.  Returns:     schemas.RoleWithRights: The roles.
     * @summary Get Project Roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectRolesRolesProjectsGet(options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).getProjectRolesRolesProjectsGet(options).then((request) => request(this.axios, this.basePath));
    }
}

